// src/services/apiService.js
import axios from 'axios';
import { toast } from 'react-toastify';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  // headers: { 'Content-Type': 'application/json' },
  timeout: 50000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Response interceptor error:', error.response?.status, error.message); // Debug log
    const message = error.response?.data?.error || error.message;
    // Skip toasts during login attempts
    if (!window.location.pathname.includes('/login')) {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Use toastId to prevent duplicates
        import('react-toastify').then(({ toast }) => {
          toast.error('Session expired. Please log in again.', { toastId: 'session-expired' });
        });
      } else if (error.response?.status === 403) {
        import('react-toastify').then(({ toast }) => {
          toast.error('Access denied.', { toastId: 'access-denied' });
        });
      } else {
        import('react-toastify').then(({ toast }) => {
          toast.error(message, { toastId: 'api-error' });
        });
      }
    }
    return Promise.reject(error);
  }
);

const apiService = {
  async request(method, url, data = null, config = {}) {
    try {
      const response = await api({ method, url, data, ...config });
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || error.message;
    }
  },
  get(url, config = {}) {
    return this.request('get', url, null, config);
  },
  post(url, data, config = {}) {
    return this.request('post', url, data, config);
  },
  put(url, data, config = {}) {
    return this.request('put', url, data, config);
  },
  delete(url, config = {}) {
    return this.request('delete', url, null, config);
  },
  async getBlob(url, config = {}) {
    try {
      const response = await api.get(url, { ...config, responseType: 'blob' });
      return { blob: response.data, contentType: response.headers['content-type'] };
    } catch (error) {
      throw error.response?.data?.error || error.message;
    }
  },
async upload(url, formData, config = {}) {
    try {
      const method = config.method || 'POST'; // Default to POST if not provided
      const response = await api({
        method,
        url,
        data: formData,
        ...config,
        headers: { ...config.headers, 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || error.message;
    }
  },
async uploadFiles(url, formData, config = {}) {
    try {
      for (let pair of formData.entries()) {
        console.log('FormData:', pair[0], pair[1]);
      }
      const method = config.method || 'POST';
      const response = await api({
        method,
        url,
        data: formData,
        ...config,
        headers: {
          ...config.headers,
          // Ensure no default Content-Type interferes
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || error.message;
    }
  },
  
  patch(url, data, config = {}) {
    return this.request('patch', url, data, config);
  },
};

export default apiService;